import {
    Component,
    OnInit,
    OnDestroy,
    ViewChild,
    ChangeDetectorRef
} from '@angular/core';
import { Title } from '@angular/platform-browser';
import { OrganisationService } from '../../../../services/dataServices/organisation-service/organisationservice';
import { OrganisationInterface } from '../../../../model/organisations/organisation-interface';
import { Subscription } from 'rxjs';
import { SidemenuServiceService } from 'src/app/services/componentServices/sidemenu-service/sidemenu-service.service';
import { DialogService } from 'src/app/services/dialog-service/dialog-service.service';
import { UserService } from 'src/app/services/user-service/userservice';
import { ProductService } from 'src/app/services/dataServices/product-service/productService';
import { Router } from '@angular/router';
import { OrganisationDeleteInterface } from 'src/app/model/organisations/organisation-delete-interface';
import { NavbarService } from 'src/app/services/componentServices/navbar-service/navbar-service';
import { HeaderServiceService } from 'src/app/services/header-service/header-service.service';
import { StripeService } from 'src/app/services/stripe-service/stripe.service';
import { MinLengthErrorStateMatcher, VALIDATORS, streetValidator } from 'src/environments/validators';
import { UtilService } from 'src/app/services/util-service/utilService';
import { AbstractControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { HOUSE_NUMBER_REGEX, PHONE_NUMBER_REGEX, CITY_REGEX, POSTAL_CODE_REGEX } from 'src/environments/constants';
import { OrganisationType } from 'src/app/model/enums/organisationType';

@Component({
    selector: 'app-organisation-information',
    templateUrl: './organisation-information.component.html',
    styleUrls: ['./organisation-information.component.css'],
    standalone: false
})
export class OrganisationInformationComponent implements OnInit, OnDestroy {
    changeOrganisationDetailsMode = false;
    private organisationDetails: OrganisationInterface;
    editForm: UntypedFormGroup;

    private sidemenuDataSubscription: Subscription;
    private activeItemSubscription: Subscription;

    private readonly domainPrefix = '@';

    public organisation: OrganisationInterface;
    public isDescriptionValid: boolean = true;

    private hasContacts: boolean;
    private showOrganisationContacts: boolean = false;

    orgaNameErrorStateMatcher = new MinLengthErrorStateMatcher(160);

    get editName(): AbstractControl { return this.editForm.get('name'); }
    get editStreet(): AbstractControl { return this.editForm.get('street'); }
    get editHNr(): AbstractControl { return this.editForm.get('hNr'); }
    get editPostalCode(): AbstractControl { return this.editForm.get('postalCode'); }
    get editCity(): AbstractControl { return this.editForm.get('city'); }
    get editUrl(): AbstractControl { return this.editForm.get('url'); }
    get editDomain(): AbstractControl { return this.editForm.get('domain'); }
    get editPhoneNumber(): AbstractControl { return this.editForm.get('phoneNumber'); }
    get type(): AbstractControl { return this.editForm.get('type'); }

    constructor(
        private organisationService: OrganisationService,
        private router: Router,
        private sidemenuService: SidemenuServiceService,
        private cd: ChangeDetectorRef,
        private dialogService: DialogService,
        private userService: UserService,
        public productService: ProductService,
        private navbarService: NavbarService,
        private titleService: Title,
        private headerService: HeaderServiceService,
        private StripeService: StripeService,
        public utilService: UtilService,
        private formBuilder: UntypedFormBuilder,
    ) {
        //Reroutes to the Marketplace if the User is not a member of the Organisation

        if (
            !this.userService.currentMemberships.find(
                (orga) =>
                    orga.organisationId ===
                    this.organisationService.activeItem.organisationId
            )
        ) {
            // TODO: beim refresh auf der Einstellungen wird man teilweise  ausgeloggt
            //  this.router.navigateByUrl("/marktplatz");
        }

        document.documentElement.style.setProperty('--scrollStatus', 'auto');
    }

    onChangeOrganisationDetailsToggle(close?: boolean): void {
        if (!close) {
            this.organisationDetails = {
                address: {
                    city: this.organisation.address.city,
                    postalCode: this.organisation.address.postalCode,
                    street: this.organisation.address.street,
                    streetAdditional: this.organisation.address.streetAdditional
                },
                domain: this.organisation.domain,
                organisationId: this.organisation.organisationId,
                organisationName: this.organisation.organisationName,
                description: this.organisation.description,
                website: this.organisation.website,
                phoneNumber: this.organisation.phoneNumber,
                fileId: this.organisation.fileId,
                organisationType: this.normalizeOrganisationTypes(this.organisation.organisationType),
            };

            this.editForm = this.formBuilder.group({
                name: [
                    this.organisationDetails.organisationName,
                    [Validators.required, Validators.maxLength(160), Validators.minLength(2)]
                ],
                type: [
                    this.normalizeOrganisationTypes(this.organisationDetails.organisationType),
                    Validators.required
                ],
                street: [
                    this.organisationDetails.address.street,
                    [Validators.required, streetValidator]
                ],
                hNr: [
                    this.organisationDetails.address.streetAdditional,
                    [Validators.required, Validators.pattern(HOUSE_NUMBER_REGEX), Validators.maxLength(15)]
                ],
                postalCode: [
                    this.organisationDetails.address.postalCode,
                    [Validators.required, Validators.pattern(POSTAL_CODE_REGEX)]
                ],
                city: [
                    this.organisationDetails.address.city,
                    [Validators.required, Validators.pattern(CITY_REGEX)]
                ],
                url: [this.organisationDetails.website, VALIDATORS.website],
                phoneNumber: [this.organisationDetails.phoneNumber, Validators.pattern(PHONE_NUMBER_REGEX)],
                domain: [this.organisationDetails.domain, Validators.required],
            });

            this.cd.detectChanges();
        }
        this.changeOrganisationDetailsMode =
            !this.changeOrganisationDetailsMode;
    }

    onChangeOrganisationDetailsConfirm(): void {
        if (this.editForm.invalid || !this.isDescriptionValid) return;
        if (this.organisationDetails.fileId == null) {
            this.dialogService.openDialog(
                'Speichern fehlgeschlagen',
                'Bitte wählen Sie ein Logo für die Organisation.'
            );
            return;
        }

        const value = this.editForm.value;
        this.organisationDetails.organisationName = value.name;
        this.organisationDetails.organisationType = this.normalizeOrganisationTypes(value.type);
        this.organisationDetails.address = {
            street: value.street,
            streetAdditional: value.hNr,
            postalCode: value.postalCode,
            city: value.city
        };
        this.organisationDetails.website = value.url;
        this.organisationDetails.phoneNumber = value.phoneNumber;
        this.organisationDetails.domain = value.domain;

        this.organisationService
            .updateOrganisation(this.organisationDetails)
            .then((org) => {
                this.organisation = org;
                this.onChangeOrganisationDetailsToggle(true);
                this.organisationService.loadOrganisationsForUser();
                this.dialogService.openDialog(
                    'Organisationsinformationen bearbeitet',
                    'Die Organisationsinformationen der Organisation ' +
                    org.organisationName +
                    ' wurden erfolgreich bearbeitet.'
                );
            })
            .catch((e) => {
                this.dialogService.openDialog(
                    'Speichern fehlgeschlagen',
                    e?.error?.message ||
                    e?.message ||
                    'Die Organisationsinformationen konnten nicht gespeichert werden.'
                );
            });
    }

    getOrgaType(): string[] {
        let result: string[] = [];
        let type = this.organisation.organisationType ?? [];
        if (type.includes(OrganisationType.PRODUCT_PROVIDER)) result.push('Produktanbieter');
        if (type.includes(OrganisationType.PRODUCT_TYPE_ASSOCIATION)) result.push('PTG-Fachgruppe');
        if (type.includes(OrganisationType.CERTIFICATION_PROVIDER))
            result.push('Zertifizierungsanbieter');
        if (type.includes(OrganisationType.CERTIFICATION_OFFICE))
            result.push('Zertifizierungsdienstleister');
        if (type.includes(OrganisationType.DATASPACE_PARTICIPANT))
            result.push('Datenraum Participant');

        return result;
    }

    isUserPlatformAdmin(): boolean {
        return this.userService.isCurrentUserPlatformAdmin();
    }

    isUserAdminOfOrganisationOrPlattformAdmin() {
        return this.userService.isUserAdminOfOrganisationOrPlattformAdmin(
            this.organisation.organisationId
        );
    }

    private normalizeOrganisationTypes(value: any): OrganisationType[] {
        const organisationTypes = Array.isArray(value) ? value : value != null ? [value] : [];
        return [...new Set(organisationTypes.filter((type) => type != null))];
    }

    onPressAskForDeleteConfirm() {
        this.organisationService
            .requestOrganisationDelete(this.organisation)
            .subscribe((response: OrganisationDeleteInterface) => {
                let text =
                    'Möchten Sie die Organisation wirklich unwiderruflich auflösen?';
                if (response) {
                    if (response.productCount > 0) {
                        text +=
                            ' ' +
                            this.pluralizeDeleteSentence(
                                'Produkt',
                                'Produkte',
                                response.productCount
                            );
                    } else if (response.certificateCount > 0) {
                        text +=
                            ' ' +
                            this.pluralizeDeleteSentence(
                                'Zertifikat',
                                'Zertifikate',
                                response.certificateCount
                            );
                    } else {
                        text +=
                            ' Dadurch werden keine Produkte oder Zertifikate gelöscht.';
                    }
                } else {
                    // Response was null (shouldn't happen) thus we don't know how many certifications or products the org has
                    text +=
                        ' Dadurch werden möglicherweise Produkte oder Zertifikate gelöscht.';
                }
                this.dialogService
                    .openConfirmDialog(
                        'Organisation löschen?',
                        'Nein',
                        'Ja',
                        text
                    )
                    .subscribe((result) => {
                        if (result) {
                            this.organisationService
                                .deleteItem(this.organisation)
                                .then(() => {
                                    this.navbarService.loadButtons();
                                    this.userService.fetchCurrentUser();
                                    this.router.navigate(['profil/settings']);
                                });
                        }
                    });
            });
    }

    private pluralizeDeleteSentence(
        singular: string,
        plural: string,
        count: number
    ): string {
        const isSingular = count === 1;
        return `Dadurch ${isSingular ? 'wird' : 'werden'} ${count} ${isSingular ? singular : plural
            } gelöscht.`;
    }

    ngOnInit(): void {
        this.sidemenuService.productsVisible = false;
        this.sidemenuDataSubscription =
            this.sidemenuService.sidemenuDataObserver.subscribe((x) =>
                this.cd.detectChanges()
            );
        this.activeItemSubscription =
            this.organisationService.activeItemObserver.subscribe(
                (orga: OrganisationInterface) => {
                    if (!orga) {
                        return;
                    }
                    this.organisation = orga;
                    this.organisation.contacts = this.organisation.contacts ?? [];
                    this.hasContacts = this.organisation.contacts.length > 0;

                    this.organisationDetails = { ...orga };
                    this.headerService.loadHeaderText(orga.organisationName);

                    this.userService.currentMemberships.forEach(
                        (memberOrga: OrganisationInterface) => {
                            if (
                                memberOrga &&
                                memberOrga.organisationId == orga.organisationId
                            ) {
                                orga.fileId = memberOrga.fileId;

                                this.titleService.setTitle(
                                    'Informationen: ' +
                                    this.organisation.organisationName +
                                    ' - BIMSWARM'
                                );
                            }
                        }
                    );
                    if (this.changeOrganisationDetailsMode) {
                        this.changeOrganisationDetailsMode =
                            !this.changeOrganisationDetailsMode;
                    }

                    if (!this.cd['destroyed']) {
                        this.cd.detectChanges();
                    }
                    this.StripeService.updateStripeUserDateBecauseNewPayment(this.organisation.organisationId).subscribe(data => { });
                }
            );
    }

    ngOnDestroy() {
        document.documentElement.style.setProperty('--scrollStatus', 'hidden');

        if (this.sidemenuDataSubscription) {
            this.sidemenuDataSubscription.unsubscribe();
        }

        if (this.activeItemSubscription) {
            this.activeItemSubscription.unsubscribe();
        }
    }

    public onDescriptionValidityChange(descriptionValid: boolean): void {
        this.isDescriptionValid = descriptionValid;
    }

    organisationContactsToggle(): void {
        this.hasContacts = this.organisationService.activeItem.contacts.length > 0;
        this.showOrganisationContacts = !this.showOrganisationContacts;
    }

    trimField(controlName: string): void {
        const control = this.editForm?.get(controlName);
        if (control) {
            control.setValue(control.value?.trim());
        }
    }

    checkPhonenumber(): boolean {
        const phone = this.editPhoneNumber.value?.trim();
        if (!phone) return true;

        const isValid = this.utilService.validateInternationalPhone(phone);
        if (!isValid) {
            this.editPhoneNumber.setErrors({ invalid: true });
            return false;
        }
        return true;
    }
}
